export default {
  name: 'pipeta',
  buttons: [
    {
      title: 'Narzędzie pipeta',
      key: 'I'
    }
  ]
}